module.exports = __webpack_public_path__ + "img/gallery-4.7c48aba7.webp";